var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.5 8.05875C2.5 4.995 5.0378 2.5 8.15567 2.5H14.3571C17.4686 2.5 20 4.9875 20 8.04625V21.9412C20 25.0063 17.4622 27.5 14.3431 27.5H8.14422C5.03144 27.5 2.5 25.0125 2.5 21.9538V20.7787V8.05875Z",
    fill: "#6B6B6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2235 14.3195L23.6663 10.6833C23.2986 10.3083 22.707 10.3083 22.3405 10.6858C21.9753 11.0633 21.9765 11.672 22.343 12.047L24.292 14.0383H22.4233H11.9354C11.418 14.0383 10.998 14.4695 10.998 15.0008C10.998 15.5333 11.418 15.9633 11.9354 15.9633H24.292L22.343 17.9545C21.9765 18.3295 21.9753 18.9383 22.3405 19.3158C22.5244 19.5045 22.7642 19.5995 23.0052 19.5995C23.2439 19.5995 23.4837 19.5045 23.6663 19.3183L27.2235 15.6833C27.4001 15.502 27.4999 15.257 27.4999 15.0008C27.4999 14.7458 27.4001 14.5008 27.2235 14.3195Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c0bd5c4e0a082f36db444b9c451c0c31.svg";
export { ForwardRef as ReactComponent };